export default __webpack_public_path__ + "static/ehm-smooth-shiny-aff079afadf2ec648482f246da6d8b67.webp";